import { render, staticRenderFns } from "./BasicinformationDetails.vue?vue&type=template&id=1c4d9bbe&scoped=true&"
import script from "./BasicinformationDetails.vue?vue&type=script&lang=js&"
export * from "./BasicinformationDetails.vue?vue&type=script&lang=js&"
import style0 from "./BasicinformationDetails.vue?vue&type=style&index=0&id=1c4d9bbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4d9bbe",
  null
  
)

export default component.exports